<template>
  <div class="progress-box shadow" v-if="$multiUploading && $multiUploading.length">
    <div class="pb-header p-3 flex">
      <p class="robo-16-400 pb-title text-white mb-0">{{$t('circle_feature.lbl_uploading')}}</p>
      <span class="ml-auto">
        <span class="w-6 h-6 flex">
          <i class="el-icon-close text-white cursor-pointer m-auto" @click="$multiUploading = []" />
        </span>
      </span>
    </div>
    <div v-for="(uploading, i) in $multiUploading" :key="i + 'multi-uploading'">
      <div class="progress">
        <div
          class="progress-bar"
          role="progressbar"
          :style="'width:' + (uploading.value || 0) + '%'"
          :aria-valuenow="uploading.value"
          aria-valuemin="0"
          aria-valuemax="100"
        ></div>
      </div>
      <div class="d-flex bg-white p-3 justify-content-between pb-body align-items-center">
        <div class="d-flex align-items-center">
          <div
            class="spinner-border mr-1"
            role="status"
            v-show="uploading.value < 100 && uploading.status === 0"
          >
            <span class="sr-only">Loading...</span>
          </div>
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            v-show="uploading.status === 2"
            class="mr-1"
          >
            <path
              d="M15.7101 8.29008C15.6171 8.19635 15.5065 8.12196 15.3847 8.07119C15.2628 8.02042 15.1321 7.99428 15.0001 7.99428C14.8681 7.99428 14.7374 8.02042 14.6155 8.07119C14.4936 8.12196 14.383 8.19635 14.2901 8.29008L12.0001 10.5901L9.71008 8.29008C9.52178 8.10178 9.26638 7.99599 9.00008 7.99599C8.73378 7.99599 8.47838 8.10178 8.29008 8.29008C8.10178 8.47838 7.99599 8.73378 7.99599 9.00008C7.99599 9.26638 8.10178 9.52178 8.29008 9.71008L10.5901 12.0001L8.29008 14.2901C8.19635 14.383 8.12196 14.4936 8.07119 14.6155C8.02042 14.7374 7.99428 14.8681 7.99428 15.0001C7.99428 15.1321 8.02042 15.2628 8.07119 15.3847C8.12196 15.5065 8.19635 15.6171 8.29008 15.7101C8.38304 15.8038 8.49364 15.8782 8.6155 15.929C8.73736 15.9797 8.86807 16.0059 9.00008 16.0059C9.13209 16.0059 9.2628 15.9797 9.38466 15.929C9.50652 15.8782 9.61712 15.8038 9.71008 15.7101L12.0001 13.4101L14.2901 15.7101C14.383 15.8038 14.4936 15.8782 14.6155 15.929C14.7374 15.9797 14.8681 16.0059 15.0001 16.0059C15.1321 16.0059 15.2628 15.9797 15.3847 15.929C15.5065 15.8782 15.6171 15.8038 15.7101 15.7101C15.8038 15.6171 15.8782 15.5065 15.929 15.3847C15.9797 15.2628 16.0059 15.1321 16.0059 15.0001C16.0059 14.8681 15.9797 14.7374 15.929 14.6155C15.8782 14.4936 15.8038 14.383 15.7101 14.2901L13.4101 12.0001L15.7101 9.71008C15.8038 9.61712 15.8782 9.50652 15.929 9.38466C15.9797 9.2628 16.0059 9.13209 16.0059 9.00008C16.0059 8.86807 15.9797 8.73736 15.929 8.6155C15.8782 8.49364 15.8038 8.38304 15.7101 8.29008ZM19.0701 4.93008C18.1476 3.97498 17.0442 3.21316 15.8241 2.68907C14.6041 2.16498 13.2919 1.88911 11.9641 1.87757C10.6363 1.86604 9.3195 2.11905 8.09054 2.62186C6.86158 3.12467 5.74506 3.8672 4.80613 4.80613C3.8672 5.74506 3.12467 6.86158 2.62186 8.09054C2.11905 9.3195 1.86604 10.6363 1.87757 11.9641C1.88911 13.2919 2.16498 14.6041 2.68907 15.8241C3.21316 17.0442 3.97498 18.1476 4.93008 19.0701C5.85255 20.0252 6.95599 20.787 8.17603 21.3111C9.39607 21.8352 10.7083 22.111 12.0361 22.1226C13.3639 22.1341 14.6807 21.8811 15.9096 21.3783C17.1386 20.8755 18.2551 20.133 19.194 19.194C20.133 18.2551 20.8755 17.1386 21.3783 15.9096C21.8811 14.6807 22.1341 13.3639 22.1226 12.0361C22.111 10.7083 21.8352 9.39607 21.3111 8.17603C20.787 6.95599 20.0252 5.85255 19.0701 4.93008ZM17.6601 17.6601C16.3521 18.9695 14.6306 19.7849 12.7889 19.9674C10.9471 20.1499 9.09908 19.6881 7.5596 18.6609C6.02012 17.6336 4.88444 16.1043 4.34605 14.3336C3.80767 12.5628 3.89988 10.6602 4.60699 8.94986C5.3141 7.23951 6.59235 5.82723 8.22397 4.95364C9.85559 4.08006 11.7396 3.79921 13.5551 4.15895C15.3706 4.5187 17.0051 5.49677 18.1803 6.92654C19.3555 8.35631 19.9986 10.1493 20.0001 12.0001C20.0036 13.0514 19.7987 14.0929 19.397 15.0645C18.9953 16.036 18.405 16.9182 17.6601 17.6601Z"
              fill="red"
            />
          </svg>
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            v-show="uploading.status === 1"
            class="mr-1"
          >
            <path
              d="M20 6L9 17L4 12"
              stroke="green"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>

          <p class="robo-16-500 mb-0">{{ uploading.name }}</p>
        </div>
        <p class="robo-16-400 mb-0">
          <span
            v-if="uploading.value && uploading.value === 100"
          >{{$t('circle_feature.lbl_uploaded_msg')}}</span>
          <span
            v-if="!uploading.value || uploading.value < 100"
          >{{$t('circle_feature.lbl_uploading')}} {{ uploading.value || 0 }}%</span>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MultiUploadProgressBox'
}
</script>

<style scoped>
.progress-box {
  width: 100%;
  max-width: 400px;
  position: absolute;
  top: 66px;
  right: 16px;
  border-radius: 10px;
  z-index: 3000;
}
.pb-header {
  background-color: #323232;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}
.progress {
  border-radius: 0;
  height: 5px;
}
.progress-bar {
  background-color: #20419b;
}
.pb-body {
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
}
</style>
